export default __webpack_public_path__ + "static/icon-teams-93e131c7634ac3e1a074d01607fb4afc.svg";